import React from 'react';
import { ComplementaryInfoContainer } from '../components/ComplementaryInfoContainer';
import PremiumSection from '../components/PremiumSection';
import { ComplementaryInfoSection } from '../sections/ComplementaryInfoSection';

export const TicketFormComplementaryInputsBlock = ({ ticketFormBodyData }) => {
  return (
    <ComplementaryInfoContainer>
      <PremiumSection>
        <ComplementaryInfoSection ticketFormBodyData={ticketFormBodyData} />
      </PremiumSection>
    </ComplementaryInfoContainer>
  );
};
